export default "__VITE_ASSET__DAGzQbxf__"